(function () {
  'use strict';

  var selector = '[data-blp-dominator]';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileViewport = window.matchMedia('(max-width: 1100px)');

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function init(section) {
    if (!section || section.dataset.blpDominatorReady === 'true') return;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-blp-dominator-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-blp-dominator-panel]'));
    var images = Array.prototype.slice.call(section.querySelectorAll('[data-blp-dominator-image]'));
    var finishLabel = section.querySelector('[data-blp-dominator-finish]');
    var mediaBadge = section.querySelector('[data-blp-dominator-media-badge]');
    var mediaIndex = section.querySelector('[data-blp-dominator-index]');
    var mediaTotal = section.querySelector('[data-blp-dominator-total]');
    var partLabel = section.querySelector('[data-blp-dominator-partline]');
    var fitmentRange = section.querySelector('[data-blp-dominator-fitment-range]');
    var fitmentPlatform = section.querySelector('[data-blp-dominator-fitment-platform]');
    var headerLabel = section.querySelector('[data-blp-dominator-header]');
    var headerDetail = section.querySelector('[data-blp-dominator-header-detail]');
    var mufflerLabel = section.querySelector('[data-blp-dominator-muffler]');
    var mufflerDetail = section.querySelector('[data-blp-dominator-muffler-detail]');
    var status = section.querySelector('[data-blp-dominator-status]');
    var productLink = section.querySelector('[data-blp-dominator-product-link]');
    var productStage = section.querySelector('[data-blp-dominator-product]');
    var progressBar = section.querySelector('[data-blp-dominator-progress]');
    var sticky = section.querySelector('.blp-dominator__sticky');
    var activeIndex = 0;
    var frame = 0;
    var flashTimer = 0;
    var settleTimer = 0;
    var swipeStart = null;
    var suppressClickUntil = 0;

    if (
      images.length < 2 ||
      tabs.length !== images.length ||
      panels.length !== images.length
    ) return;
    section.dataset.blpDominatorReady = 'true';

    function setActive(nextIndex, flash, announce) {
      nextIndex = clamp(nextIndex, 0, images.length - 1);
      var changed = nextIndex !== activeIndex;
      activeIndex = nextIndex;

      var activeImage = images[activeIndex];
      var activeFinish = activeImage.dataset.blpDominatorImage;
      var activeProduct = activeImage.dataset.product || activeImage.dataset.finish || 'displayed system';

      tabs.forEach(function (tab, index) {
        var selected = index === activeIndex;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.blpDominatorPanel !== activeFinish;
      });

      images.forEach(function (image, index) {
        var selected = index === activeIndex;
        image.classList.toggle('is-active', selected);
        image.classList.toggle('is-before', index < activeIndex);
        image.classList.toggle('is-after', index > activeIndex);
        image.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });

      if (finishLabel) finishLabel.textContent = activeImage.dataset.finish || '';
      if (mediaBadge) mediaBadge.textContent = activeImage.dataset.badge || '';
      if (mediaIndex) mediaIndex.textContent = ('0' + (activeIndex + 1)).slice(-2);
      if (mediaTotal) mediaTotal.textContent = ('0' + images.length).slice(-2);
      if (partLabel) partLabel.textContent = activeImage.dataset.partline || '';
      if (fitmentRange) fitmentRange.textContent = activeImage.dataset.fitmentRange || '';
      if (fitmentPlatform) fitmentPlatform.textContent = activeImage.dataset.fitmentPlatform || '';
      if (headerLabel) headerLabel.textContent = activeImage.dataset.header || '';
      if (headerDetail) headerDetail.textContent = activeImage.dataset.headerDetail || '';
      if (mufflerLabel) mufflerLabel.textContent = activeImage.dataset.muffler || '';
      if (mufflerDetail) mufflerDetail.textContent = activeImage.dataset.mufflerDetail || '';

      if (productLink) {
        productLink.href = activeImage.dataset.url || productLink.href;
        productLink.setAttribute(
          'aria-label',
          'Shop the Khrome Werks ' +
            activeProduct +
            '.' +
            (mobileViewport.matches ? ' Swipe left or right to switch systems.' : '')
        );
      }

      if (announce && status) {
        status.textContent =
          'System ' +
          (activeIndex + 1) +
          ' of ' +
          images.length +
          ': ' +
          activeProduct +
          '. ' +
          (activeImage.dataset.fitmentRange || '') +
          ' ' +
          (activeImage.dataset.fitmentPlatform || '');
      }

      section.dataset.finish = activeFinish;

      if ((changed || flash) && productStage && !reducedMotion.matches) {
        window.clearTimeout(flashTimer);
        productStage.classList.remove('is-flashing');
        void productStage.offsetWidth;
        productStage.classList.add('is-flashing');
        flashTimer = window.setTimeout(function () {
          productStage.classList.remove('is-flashing');
        }, 220);
      }
    }

    function update() {
      frame = 0;
      var rect = section.getBoundingClientRect();
      var stickyTop = sticky ? parseFloat(window.getComputedStyle(sticky).top) || 0 : 0;
      var stickyHeight = sticky ? sticky.offsetHeight : window.innerHeight;
      var travel = Math.max(section.offsetHeight - stickyHeight, 1);
      var progress = clamp((stickyTop - rect.top) / travel, 0, 1);
      var nextIndex = Math.min(Math.floor(progress * images.length), images.length - 1);
      var changed = nextIndex !== activeIndex;

      setActive(nextIndex, changed, false);
      section.style.setProperty('--blp-dominator-progress', progress.toFixed(4));
      if (progressBar) progressBar.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
    }

    function requestUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);

      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settleUpdate, 90);
    }

    function settleUpdate() {
      window.clearTimeout(settleTimer);
      settleTimer = 0;

      if (frame) {
        window.cancelAnimationFrame(frame);
        frame = 0;
      }

      update();
    }

    function scrollToIndex(index, behavior) {
      var sectionTop = section.getBoundingClientRect().top + window.scrollY;
      var stickyTop = sticky ? parseFloat(window.getComputedStyle(sticky).top) || 0 : 0;
      var stickyHeight = sticky ? sticky.offsetHeight : window.innerHeight;
      var travel = Math.max(section.offsetHeight - stickyHeight, 1);
      var ratio = (index + 0.5) / images.length;
      window.scrollTo({ top: sectionTop - stickyTop + ratio * travel, behavior: behavior });
    }

    function selectTab(index, moveFocus) {
      setActive(index, true, true);
      scrollToIndex(index, reducedMotion.matches ? 'auto' : 'smooth');
      if (moveFocus && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, tabIndex) {
      tab.addEventListener('click', function () {
        selectTab(tabIndex, false);
      });

      tab.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) === -1) return;
        event.preventDefault();

        var nextIndex = tabIndex;
        if (event.key === 'ArrowLeft') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (tabIndex + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        selectTab(nextIndex, true);
      });
    });

    function onPointerDown(event) {
      if (!mobileViewport.matches || (event.button !== undefined && event.button !== 0)) return;
      swipeStart = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
      if (productLink.setPointerCapture) productLink.setPointerCapture(event.pointerId);
    }

    function onPointerEnd(event) {
      if (!swipeStart || event.pointerId !== swipeStart.id) return;

      var deltaX = event.clientX - swipeStart.x;
      var deltaY = event.clientY - swipeStart.y;
      var isHorizontalSwipe = Math.abs(deltaX) >= 38 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;
      swipeStart = null;

      if (!isHorizontalSwipe) return;
      suppressClickUntil = Date.now() + 550;

      var nextIndex = clamp(activeIndex + (deltaX < 0 ? 1 : -1), 0, images.length - 1);
      if (nextIndex === activeIndex) return;
      setActive(nextIndex, true, true);
      scrollToIndex(nextIndex, 'auto');
    }

    function onPointerCancel() {
      swipeStart = null;
    }

    function onProductClick(event) {
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    function onDragStart(event) {
      event.preventDefault();
    }

    if (productLink) {
      productLink.addEventListener('pointerdown', onPointerDown);
      productLink.addEventListener('pointerup', onPointerEnd);
      productLink.addEventListener('pointercancel', onPointerCancel);
      productLink.addEventListener('click', onProductClick, true);
      productLink.addEventListener('dragstart', onDragStart);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('scrollend', settleUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    section._blpDominatorCleanup = function () {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('scrollend', settleUpdate);
      window.removeEventListener('resize', requestUpdate);
      window.cancelAnimationFrame(frame);
      window.clearTimeout(flashTimer);
      window.clearTimeout(settleTimer);

      if (productLink) {
        productLink.removeEventListener('pointerdown', onPointerDown);
        productLink.removeEventListener('pointerup', onPointerEnd);
        productLink.removeEventListener('pointercancel', onPointerCancel);
        productLink.removeEventListener('click', onProductClick, true);
        productLink.removeEventListener('dragstart', onDragStart);
      }
    };

    setActive(0, false, false);
    update();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(selector), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches && event.target.matches(selector)
      ? event.target
      : event.target.querySelector(selector);
    if (section && section._blpDominatorCleanup) section._blpDominatorCleanup();
  });
})();
